import * as React from "react";

function ArchiveIconWithBackground() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
    >
      <g
        id="Group_5094"
        data-name="Group 5094"
        transform="translate(-6013 -6700)"
      >
        <circle
          id="Ellipse_106"
          data-name="Ellipse 106"
          cx="50"
          cy="50"
          r="50"
          transform="translate(6013 6700)"
          fill="#e8fcff"
        />
        <path
          id="Path_1447"
          data-name="Path 1447"
          d="M50,0H0V15H5V40H45V15h5ZM10,15H40V35H10ZM45,5v5H5V5ZM32.5,20h-15v5h15Z"
          transform="translate(6038 6730)"
          fill="#00c4de"
        />
      </g>
    </svg>
  );
}

export default ArchiveIconWithBackground;
